import mod from "-!../../../../../../../node_modules/babel-loader/lib/index.js!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./registration-by-email-confirmation.vue?vue&type=script&lang=js"; export default mod; export * from "-!../../../../../../../node_modules/babel-loader/lib/index.js!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./registration-by-email-confirmation.vue?vue&type=script&lang=js"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/quick-login-reg/registration-by-email-confirmation.vue?vue&type=script&lang=js
// module id = n2c2
// module chunks = 0